import { Text, Image, Button } from '@msc-b2c/shared-components';
import { VoyagerClubTeaserProps } from '@msc-b2c/interfaces/types';
import styles from './voyagerclubteaser.module.scss';
import { useEffect } from 'react';

export function VoyagerClubTeaser({
  bannerImageUrl,
  bannerImageAlt = '',
  bannerTitle = '',
  bannerSubtitle = '',
  bannerButtonLabel = '',
  bannerButtonUrl,
  isVisible = true,
  loading = false,
  noHorizzontalPadding = false,
  noBorder = false,
}: Readonly<VoyagerClubTeaserProps>) {
  useEffect(() => {
    if (!loading) {
      const skeleton = document.querySelector('.voyagers-club-teaser-skeleton');
      skeleton?.remove();
    }
  }, [loading]);

  if (!isVisible) {
    return null;
  }

  if (loading) {
    return (
      <div className="voyagers-club-teaser-skeleton">
        <div className="voyagers-club-header">
          <div className="skeleton-box skeleton-box--title"></div>
          <div className="skeleton-box skeleton-box--text"></div>
          <div className="skeleton-box skeleton-box--text-short"></div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={[
        styles['cmp-voyagerclub-teaser'],
        noHorizzontalPadding ? styles['cmp-voyagerclub-teaser__no-padding'] : '',
        noBorder ? styles['cmp-voyagerclub-teaser__no-border'] : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {bannerImageUrl && (
        <div className={styles['cmp-voyagerclub-teaser__image-container']}>
          <Image
            src={bannerImageUrl}
            alt={bannerImageAlt}
            loading="lazy"
          />
        </div>
      )}
      <div className={styles['cmp-voyagerclub-teaser__content']}>
        <div className={styles['cmp-voyagerclub-teaser__text-container']}>
          <Text
            text={bannerTitle}
            styleOption={styles['cmp-voyagerclub-teaser__text-container__title']}
          />
          <Text
            text={bannerSubtitle}
            styleOption={styles['cmp-voyagerclub-teaser__text-container__subtitle']}
          />
        </div>
        {bannerButtonLabel && (
          <div className={styles['cmp-voyagerclub-teaser__button-container']}>
            <Button
              text={bannerButtonLabel}
              buttonLink={bannerButtonUrl ? { url: bannerButtonUrl } : undefined}
              styleOption="cmp-button__primary"
              accessibilityLabel={bannerButtonLabel}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default VoyagerClubTeaser;
